import React from 'react'
import cn from 'classnames'
import Loader from './Loader'

import './loader.scss'

function Loading(props) {
  if (props.error) {
    return (
      <div className="loader-container">Error! Please refresh the page</div>
    )
  }
  if (props.pastDelay) {
    return (
      <div
        className={cn('loader-container', {
          'relative-loader': props.isRelativeLoader,
        })}>
        <Loader />
      </div>
    )
  }

  return null // Avoiding Flash Of Loading Component (<200ms)
}

export default Loading
